export default __webpack_public_path__ + "static/Romie-Bold-88d14553a3fbd226f1f2d91c1f4eb893.woff";